import { useUnreadNotificationCount } from '@servicetim/ui/api';
import { Badge } from '@servicetim/ui/components';
import { Link } from '@tanstack/react-router';
import { Bell } from 'lucide-react';

/** Unread-count bell for the shell header; links to `/notifications`. */
export function NotificationBell() {
  const unread = useUnreadNotificationCount();
  const count = unread.data ?? 0;
  return (
    <Link
      to="/notifications"
      className="relative flex size-9 items-center justify-center rounded-md text-fg-muted hover:bg-surface-sunken hover:text-fg"
      aria-label={count > 0 ? `Notifications (${count} unread)` : 'Notifications'}
    >
      <Bell className="size-4" aria-hidden="true" />
      {count > 0 ? (
        <Badge
          variant="destructive"
          className="-top-1 -right-1 absolute h-4 min-w-4 justify-center rounded-full px-1 text-[10px]"
        >
          {count > 99 ? '99+' : count}
        </Badge>
      ) : null}
    </Link>
  );
}
